export const GET_ALL_FAULTS = "GET_ALL_FAULTS"
export const SEARCH_FAULT = "SEARCH_FAULT"
export const GET_FAULT = "GET_FAULT"
export const UPDATE_FAULT = "UPDATE_FAULT"
export const ADD_FAULT = "ADD_FAULT"
export const DELETE_FAULT = "DELETE_FAULT"
